<template>
<div style="width: 100%">
	<v-subheader>{{$t('employers.employers')}}</v-subheader>
	<v-tooltip top slot="activator">
		<v-btn
			:loading="isLoadingCreateEmployer"
			slot="activator"
			@click="addEmployer"
			color="indigo lighten-3"
			dark
			fab
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('employers.add_employer')}}</span>
	</v-tooltip>
	<v-card style="width: 100%">
		<v-card-title>
			{{$t('employers.employers')}}
			<v-spacer />
			<v-text-field
				v-model="search"
				append-icon="search"
				:label="$t('workers.search')"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="employers"
			:pagination.sync="pagination"
			:loading="loading"
			:total-items="totalItems"
			:rows-per-page-items="rowsPerPageItems"
		>
			<template slot="headers" slot-scope="props">
				<tr>
					<th
						v-for="header in props.headers"
						:key="header.text"
						:class="['table-head-column column sortable text-xs-' +
							(header.align ? header.align : 'left'),
							pagination.descending ? 'desc' : 'asc',
							header.value === pagination.sortBy ? 'active' : '']"
						@click="changeSort(header.value, header.sortable)"
					>
						<v-icon small v-if="header.sortable">arrow_upward</v-icon>
						{{ header.text }}
					</th>
				</tr>
			</template>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.person_firstname }}</td>
				<td>{{ props.item.person_lastname }}</td>
				<td class="text-xs-right">
					<v-btn fab dark small color="indigo lighten-2" :to="'/employers/' + props.item.id">
						<v-icon dark>edit</v-icon>
					</v-btn>
				</td>
			</template>
			<v-alert slot="no-results" :value="true" color="error" icon="warning">
				{{$t('common.no_result', {search})}}
			</v-alert>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import { TEMPLATE_EMPLOYER, HEADERS_TABLE_EMPLOYER } from '../constants'
import {localeHeadersWorkers} from "../utils/helpers";

export default {
	data: (vm) => ({
		search: '',
		pagination: {
			page: 1,
			rowsPerPage: 25,
			sortBy: 'id',
			descending: 'asc'
		},
		totalItems: 0,
		rowsPerPageItems: [25, 50, 100, 200],
		headers: localeHeadersWorkers(HEADERS_TABLE_EMPLOYER, vm.$t)
	}),
	created() {
		this.search = this.$route.query.search ? this.$route.query.search : ''
		this.pushQuery(this.$route.query)
	},
	computed: {
		...mapState({
			isLoadingCreateEmployer: ({ employers }) =>
				employers.isLoadingCreateEmployer,
			employers: ({ employers }) => employers.list,
			meta: ({ employers }) => employers.meta,
			loading: ({ employers }) => employers.loading
		})
	},
	destroyed() {
		this.setList({
			data: []
		})
	},
	methods: {
		...mapActions({
			createEmployer: 'employers/createEmployer',
			getListEmployer: 'employers/fetch'
		}),
		...mapMutations({
			setList: 'employers/setList'
		}),
		addEmployer() {
			this.createEmployer({ ...TEMPLATE_EMPLOYER })
		},
		changeSort (column, sortable) {
			if(!sortable) {
				return
			}
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending
			} else {
				this.pagination.sortBy = column
				this.pagination.descending = false
			}
		},
		updatePagination() {
			this.getListEmployer(this.$route.query)
				.then(() => {
					this.totalItems = this.meta ? this.meta.total : null
				})
		},
		pushQuery (old_query = null) {
			let query = {
				count: this.pagination.rowsPerPage.toString(),
				offset: (this.pagination.rowsPerPage * (this.pagination.page - 1)).toString(),
				sortBy: this.pagination.sortBy,
				descending: this.pagination.descending ? 'asc' : 'desc'
			}
			this.search ? query.search = this.search.toLowerCase() : ''
			this.$router.push({ query: query })
			if(JSON.stringify(old_query) == JSON.stringify(query)) {
				this.updatePagination()
			}
		}
	},
	watch: {
		'pagination.page' () {
			this.pushQuery()
		},
		'pagination.rowsPerPage' () {
			this.pushQuery()
		},
		'pagination.descending' () {
			this.pushQuery()
		},
		'$route.query'() {
			this.updatePagination()
		},
		search () {
			this.pushQuery()
		}
	}
}
</script>
